/**
 *
 * @page 企业中心/数据看板/管理员界面
 *
 **/
import { useEffect, useState } from 'react';
import OverviewCard from './OverviewCard';
import MesaggeCard from './MesaggeCard';
import StatusStatistics from './StatusStatistics';
import SatisfactionStatistics from './SatisfactionStatistics';
import StageStatistics from './StageStatistics';
import QualityStatistics from './QualityStatistics';
import ProjectStatistics from './ProjectStatistics';
import AbnormalityStatistics from './AbnormalityStatistics';
import TodoStatistics from './TodoStatistics';
import QuickStart from './quickStart';
import { guidance } from '&/api/personCenter/dataBoard';
import OrganizationSelect from '@/components/UserCenter/OrganizationSelect';
import { getAllData, getManegers } from '@/api/personCenter/dataBoard';
import { useStoreState } from '&/utils/customHooks';
import { DAY_OPTIONS } from './constants';
import { observer } from 'mobx-react';
import { Button, Drawer } from 'antd';
import SvgIcon from '&/components/SvgIcon';

import './AdministratorPage.scss';

function AdministratorPage() {
    const [baseParams, setBaseParams] = useState({
        entId: null,
        dap: 1,
        isAll: 1,
        days: 30,
    });
    const [openDrawer, setOpenDrawer] = useState(false);
    const [guidanceData, setGuidanceData] = useState({});
    const [showQuickStart, setShowQuickStart] = useState(false);

    const dataBoard = useStoreState('dataBoard');

    useEffect(() => {
        guidance().then(res => {
            if (res.code === 0) {
                if (!res.data) {
                    setGuidanceData({
                        entRole: '0',
                        entOrg: '0',
                        entPlanTemp: '0',
                        entNotepadTemp: '0',
                        entExamineTemp: '0',
                        entInspectTemp: '0',
                        entMessageTemp: '0',
                    });
                    setShowQuickStart(true);
                } else {
                    const keys = Object.keys(res.data);
                    const total = keys.filter(key => key.startsWith('ent'));
                    const guidance = {};
                    total.forEach(key => (guidance[key] = res.data[key]));
                    setGuidanceData(guidance);
                    if (res.data.status === '0') {
                        setShowQuickStart(true);
                    } else if (res.data.status === '1') {
                        setShowQuickStart(false);
                        setOpenDrawer(false);
                    }
                }
            }
        });
    }, []);

    useEffect(() => {
        const { entId } = dataBoard;
        const next = {
            ...baseParams,
            entId,
            isAll: !entId ? 1 : 2,
        };
        setBaseParams(next);
        queryManagerOptions(next);
        queryAllData(next);
    }, [dataBoard.entId]);

    // 项目经理字典

    const dftManeger = {
        value: null,
        label: intl.get('baseComponents.baseInfo.projectManager'),
    };
    const [managerOpts, setManagerOpts] = useState([dftManeger]);

    function queryManagerOptions(payload) {
        const PARAMS = {
            isAll: payload.isAll,
            roleId: 2, // 项目经理
        };
        if (payload.entId) {
            PARAMS.entId = payload.entId;
        }

        getManegers(PARAMS).then(({ data }) => {
            const opts = [dftManeger];
            for (const el of data.list) {
                opts.push({
                    value: el.userId,
                    label: el.username,
                });
            }

            setManagerOpts(opts);
        });
    }

    // 查询所有数据

    const [compositeData, setCompositeData] = useState({
        getProjectOverall: {},
    });

    function queryAllData(payload) {
        if (!payload.entId) {
            delete payload.entId; // 让axios 自带entId
        }
        getAllData(payload).then(({ data }) => {
            setCompositeData(data);
        });
    }

    const closeSettingHandler = () => {
        guidance({
            status: 1,
        }).then(res => {
            if (res.code === 0) {
                setOpenDrawer(false);
                setShowQuickStart(false);
            }
        });
    };

    return (
        <div className="data-board">
            <OrganizationSelect />
            <OverviewCard
                defaultValue={compositeData.getProjectOverall}
                baseParams={baseParams}
                managerOpts={managerOpts}
            />
            <MesaggeCard
                defaultValue={compositeData.getMessageWaitAndSteward}
                baseParams={baseParams}
                managerOpts={managerOpts}
            />
            <StatusStatistics
                defaultValue={compositeData.getProjectStatus}
                baseParams={baseParams}
                managerOpts={managerOpts}
                dayOpts={DAY_OPTIONS(intl)}
                isAdmin
            />
            <SatisfactionStatistics
                defaultValue={compositeData.getProjectOpinion}
                baseParams={baseParams}
                managerOpts={managerOpts}
                dayOpts={DAY_OPTIONS(intl)}
                isAdmin
            />
            <StageStatistics
                defaultValue={compositeData.getStageOpinion}
                baseParams={baseParams}
                dayOpts={DAY_OPTIONS(intl)}
                isAdmin
            />
            <QualityStatistics
                defaultValue={compositeData.getExamineQuality}
                baseParams={baseParams}
                managerOpts={managerOpts}
                dayOpts={DAY_OPTIONS(intl)}
                isAdmin
            />
            <AbnormalityStatistics
                defaultValue={compositeData.getExamineException}
                baseParams={baseParams}
                managerOpts={managerOpts}
                dayOpts={DAY_OPTIONS(intl)}
            />

            <TodoStatistics
                defaultValue={compositeData.getNotepadException}
                baseParams={baseParams}
                managerOpts={managerOpts}
                dayOpts={DAY_OPTIONS(intl)}
            />
            <ProjectStatistics
                defaultValue={compositeData.getProjectDelayOrFinish}
                baseParams={baseParams}
                managerOpts={managerOpts}
                isAdmin
            />
            <Drawer
                width={300}
                className="quick-start-drawer"
                visible={openDrawer}
                placement="right"
                size="large"
                closable={false}
                destroyOnClose
                maskClosable
                onClose={() => setOpenDrawer(false)}>
                <QuickStart
                    closeHandler={() => setOpenDrawer(false)}
                    guidanceData={guidanceData}
                    closeSettingHandler={() => closeSettingHandler()}
                />
            </Drawer>
            {showQuickStart && (
                <Button
                    className="quick-start-btn"
                    type="primary"
                    size="large"
                    shape="round"
                    icon={
                        <SvgIcon
                            iconName="Icon-Sstopwatch"
                            className="quick-icon"
                        />
                    }
                    onClick={() => setOpenDrawer(true)}>
                    {intl.get('dataBoard.quickStart.title')}
                </Button>
            )}
        </div>
    );
}

export default observer(AdministratorPage);
